<script setup>
import { BCard, BFormCheckbox, BFormGroup, BCol, BRow, BButton } from 'bootstrap-vue-next';
import { computed } from 'vue';

import LanguageFilter from './LanguageFilter.vue';
import ProjectFilter from './ProjectFilter.vue';

const props = defineProps({
  shownLabels: {
    type: Array,
    required: true,
  },
  availableProjects: {
    type: Array,
    required: true,
  },
  availableLanguages: {
    type: Array,
    required: true,
  },
});

const midpoint = computed(() => Math.ceil(props.shownLabels.length / 2));
const firstColumnLabels = computed(() => props.shownLabels.slice(0, midpoint.value));
const secondColumnLabels = computed(() => props.shownLabels.slice(midpoint.value));

const selectedLabels = defineModel('selectedLabels', {
  type: Array,
  required: true,
});

const selectedProjects = defineModel('selectedProjects', {
  type: Array,
  required: true,
});

const selectedLanguages = defineModel('selectedLanguages', {
  type: Array,
  required: true,
});

const allSelected = computed(() => selectedLabels.value.length === props.shownLabels.length);

const toggleSelectAll = () => {
  selectedLabels.value = allSelected.value ? [] : [...props.shownLabels];
};
</script>

<template>
  <h3>Filter</h3>
  <BCard class="mb-3">
    <ProjectFilter
      v-model:selected-projects="selectedProjects"
      :available-projects="availableProjects"
    />
    <LanguageFilter
      v-model:selected-languages="selectedLanguages"
      :available-languages="availableLanguages"
    />
    <BFormGroup label="Labels">
      <BButton
        size="sm"
        variant="outline-secondary"
        class="mb-2"
        @click="toggleSelectAll"
      >
        {{ allSelected ? 'Deselect all' : 'Select all' }}
      </BButton>
      <BRow>
        <BCol
          cols="12"
          md="6"
        >
          <BFormCheckbox
            v-for="label in firstColumnLabels"
            :key="label"
            v-model="selectedLabels"
            :value="label"
          >
            {{ label }}
          </BFormCheckbox>
        </BCol>
        <BCol
          cols="12"
          md="6"
        >
          <BFormCheckbox
            v-for="label in secondColumnLabels"
            :key="label"
            v-model="selectedLabels"
            :value="label"
          >
            {{ label }}
          </BFormCheckbox>
        </BCol>
      </BRow>
    </BFormGroup>
  </BCard>
</template>
